<template>

	<iframe ref="iframe" :src="sendSmsUrl" width="100%" height="700" frameborder="0" scrolling="auto"/>
		
</template>

<script>
export default {
		data() {
			return {
				sendSmsUrl: 'http://aiot.yunkawulian.com/m/smssend.html'
				// sendSmsUrl: 'http://www.yunkawulian.com:89/sim/'
				//sendSmsUrl: 'http://www.yunkawulian.com:8080/sms/wechat/sendmessage'
			}
		},
		methods: {
			loaded() {
				console.log("cccccccccccccccccc:"+this.$refs.iframe.contentWindow.document.body.clientHeight);
			}
		},
		mounted() {

		}

	}
</script>


// WEBPACK FOOTER //
// sendsms.vue?562aada8